import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private isDarkMode = false;

  get isDarkModeEnabled(): boolean {
    return this.isDarkMode;
  }  

  toggleDarkMode(isChecked: boolean) {
    this.isDarkMode = isChecked;
    this.applyTheme();
    localStorage.setItem('isDarkMode', JSON.stringify(isChecked));
  }

  applyTheme() {
    document.body.classList.toggle('dark-mode-body', this.isDarkMode);
    
    const header = document.querySelector('.header');
    const sideMenu = document.querySelector('.sidenav');
    const pageTitles = document.querySelectorAll('.page-title');
    const menuTitles = document.querySelectorAll('.menu-title');

    if (sideMenu) {
      sideMenu.classList.toggle('dark-mode-side-menu', this.isDarkMode);
    }

    if (header) {
      header.classList.toggle('dark-mode-header', this.isDarkMode);
    }

    pageTitles.forEach((pageTitle) => {
      pageTitle.classList.toggle('dark-mode-page-title', this.isDarkMode);
    });

    menuTitles.forEach((menuTitle) => {
      menuTitle.classList.toggle('dark-mode-menu-title', this.isDarkMode);
    });
  }

  initializeTheme() {
    const storedTheme = localStorage.getItem('isDarkMode');
    if (storedTheme) {
      this.isDarkMode = JSON.parse(storedTheme);
      this.applyTheme();
    }
  }
}


